import { AfterViewInit, ANALYZE_FOR_ENTRY_COMPONENTS, Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Routes, Router, ActivatedRoute } from '@angular/router';
import { RoutesService } from '../../services/routes.service';
import { ThemeService } from '../../services/theme.service';
import { Utenteservice } from '../../services/utente.service';
import { confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { Apiservice } from '../../services/api.service';
import { alert } from "devextreme/ui/dialog";
import { AnaProduttoriComponent } from '../../views/ana-produttori/ana-produttori.component';

import { ComponentService } from '../../services/component.service';
import { EmailComponent } from '../../widgets/email/email.component';
import { environment } from '../../../environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { NicaLicenzaInfoComponent } from '../../components/shared/nica-licenza-info/nica-licenza-info.component';
import { AnacomuniComponent } from '../../components/anagrafiche/anacomuni/anacomuni.component';
import { CerComponent } from '../../components/anagrafiche/cer/cer.component';
import { NicaFileManagerComponent } from '../../components/nica-file-manager/nica-file-manager.component';
import { NicaMainMenuComponent } from '../nica-main-menu/nica-main-menu.component';
import { NicaRightPanelComponent } from '../../components/shared/nica-right-panel/nica-right-panel.component';
import { DxFormComponent } from 'devextreme-angular';

import { NewNicaFormComponent } from '../../components/nica-form/new-nica-form.component';
import { NicaFormComponent } from '../../components/nica-form/nica-form.component';
import { Utente } from '../../class/userinterface';
import { NicaMenuService } from '../../services/nica-menu.service';
import { ConditionalExpr } from '@angular/compiler';
import { messagefromComponent } from '../../class/appinterface';
import { StaticMenuComponent } from '../static-menu/static-menu.component';
import { event } from 'jquery';

export interface IUpdateProfiloRequest {
    id: any,
    userName: any,
    nomeCompleto: any
    emailRecupero: any,
    emailComunicazioni: any,
    foto: any,
    accessoConPIN: any,
    codiceFiscale: any,
    telefono: any,

};

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss', '../static-menu-functions/static-menu-functions.component.css'],
    providers: [RoutesService]
})
export class HeaderComponent implements OnInit, AfterViewInit {
    @ViewChild('dynamicInsert', { static: false, read: ViewContainerRef }) dynamicInsert: ViewContainerRef;
    @ViewChild('menu', { static: false }) menu: NicaMainMenuComponent
    @ViewChild('pannelloLateraleDestro', { static: false }) pannelloLateraleDestro: NicaRightPanelComponent;
    @ViewChild('formProfiloUtente', { static: false }) formProfiloUtente: DxFormComponent;
    @ViewChild('profiloForm', { static: false }) profiloForm: NewNicaFormComponent;
    @ViewChild('cambioPasswordForm', { static: false }) cambioPasswordForm: NewNicaFormComponent;

    // Variabile per memorizzare l'URL dell'immagine attuale
    currentImageUrl: string | null = null;
    swagger_endpoint = environment.SWAGGER || ''
    Versione=environment.VERSIONE;
    //@ViewChild('dynamicInsert', { static: false }) dynamicInsert: ViewContainerRef;
    Result: OverlaySideFormService = null;
    menuAdmin = false;
    isOnLine;
    linkDiretta;
    now: Date = new Date();
    AnniRiferimento = [];
    popupComponentVisible = false;
    popupComponentTitle = ""
    isDrawerOpen = false;
    popupListaVisible = false;
    messageFromComponent;
    salvaButtonOptions: any;
    closeButtonOptions: any;
    closeButtonOptionsProfilo: any;
    closePasswordButtonOptions: any;
    cambiaPasswordButtonOptions: any;
    positionOf: string;
    IdtipoNotifica: number;
    token;
    passwordVisibility: { [key: string]: boolean } = {
        vecchiaPassword: false,
        nuovaPassword: false,
        ripetiNuovaPassword: false
    };
    isPasswordVisible: boolean = false; // Aggiungi questo flag
    base_api_url;
    tipoutente = "";
    descrizionetipoutente = "";
    NumTabsOpen = 1;
    licenza = "";
    nomeutente;
    defaultVisible;
    pippo;
    lout = false;
    checkBoxValue: boolean;

    passwordFormData = {
        vecchiaPassword: "",
        nuovaPassword: "",
        ripetiNuovaPassword: ""
    };

    bottoniProfiloForm = [
        {
            location: "after",
            stylingMode: "text",
            widget: "dxButton",
            locateInMenu: "never",
            text: 'Salva',
            icon: "glyphicon mdi mdi-content-save-outline",
            event: 'salva',
            cssClass: 'salvaButtonExcelExporter',
            class: 'salvaButtonExcelExporter',
        },
        {
            location: "after",
            stylingMode: "text",
            widget: "dxButton",
            locateInMenu: "never",
            text: 'Annulla',
            icon: "glyphicon glyphicon icon-annulla-form",
            event: 'annulla',
            cssClass: 'escludiQuesto'
        },
    ];

    bottoniCambioPassword = [
        {
            location: "after",
            stylingMode: "text",
            widget: "dxButton",
            locateInMenu: "never",
            text: 'Salva',
            icon: "glyphicon mdi mdi-content-save-outline",
            event: 'salva',
            cssClass: 'salvaButtonExcelExporter',
            class: 'salvaButtonExcelExporter',
        },
        {
            location: "after",
            stylingMode: "text",
            widget: "dxButton",
            locateInMenu: "never",
            text: 'Annulla',
            icon: "glyphicon glyphicon icon-annulla-form",
            event: 'annulla',
            cssClass: 'escludiQuesto'
        },
    ];

    popupCambioVisible = false;
    popupVisible = false;
    InfoLicenze = {};
    foto = "assets/images/img_avatar2.png";
    foto1 = "assets/images/img_avatar2.png";
    menuRoutes: Routes;
    currentTheme = window.localStorage["salesViewerTheme"] || "greenmist";

    tipoAccesso: any[] = [
        {
            id: 0,
            value: 'Autenticazione Semplice'
        },
        {
            id: 1,
            value: 'Doppia Autenticazione'
        }
    ];
    tipoNotifica: any[] = [
        {
            id: 0,
            desvalue: 'Email'
        },
        {
            id: 1,
            desvalue: 'SMS'
        }
    ];
    stato: any[] = [
        {
            id: 0,
            value: 'Sospeso'
        },
        {
            id: 1,
            value: 'Attivo'
        }
    ];
    menuUtente = [];
    menuUtilities = [{
        text: "",
        icon: "mdi mdi-settings-outline",
        items: [
            { text: "Glossario Form Template", value: "glossary", icon: "icon-elenco-puntato", visible: true },
            { text: "Email", value: "email", icon: "icon-mail" },
            { text: "File Manager", value: "filemanager", icon: "icon-cartella" },
            { text: "Test Lista", value: "testLista", icon: "icon-elenco-puntato" },
            { text: "Test R.E.N.T.R.i", value: "rentri", icon: "icon-freccia-barra-menu-laterale" },
        ]

    }]
    menuThemes = [{
        text: "",
        icon: "assets/images/color-scheme-" + this.currentTheme + ".svg",
        items: [
            { text: "Carmine", value: "carmine", icon: "assets/images/color-scheme-carmine.svg" },
            { text: "Dark Moon", value: "darkmoon", icon: "assets/images/color-scheme-darkmoon.svg" },
            { text: "Green Mist", value: "greenmist", icon: "assets/images/color-scheme-greenmist.svg" },
            { text: "Dark Violet", value: "darkviolet", icon: "assets/images/color-scheme-darkviolet.svg" },
            { text: "Soft Blue", value: "softblue", icon: "assets/images/color-scheme-softblue.svg" },

        ]
    }];

    headerOption: any = [];
    connesso: boolean;
    DB: any;
    AziendaDiLavoro: number;
    ExAziendaDiLavoro: number;
    getCurrentLicenza: string;
    DescrizioneLicenza: any;
    currenAnnoRiferimento: string;
    Tab: any;
    ShowRentri: boolean;


    btnLogOut(e) {

        /*   this.router.navigate(['/login']).then(() => {
           

          });
           */

        this.router.navigate(['/'], {
            skipLocationChange: false,
            replaceUrl: true
        }).then(() => {
            // Forzo a naviagare verso questa url per aggiornare i dati. 
            this.router.navigate(['/login']);

            sessionStorage.removeItem('currentTabsItems')
            sessionStorage.removeItem('navComponent')
            sessionStorage.removeItem('currentTabsData')

        });
    }
    onUploadError(value) {
        let messageHtml = this.apiservice.parseHttpErrorResponse(value.request)
        this.popupVisible = false;
        /*alert(messageHtml, "Errore Sistema");
        this.utenteService.LogOut();
        this.router.navigateByUrl("/");
        console.log(value);*/
    }
    onUpload(value) {
        const current = new Date();
        const timestamp = current.getTime();
        //{"codeMessage":0,"descrMessage":"13.png"}
        //console.log("Dopo Upload ",value['descrMessage']);
        //alert(value['descrMessage']);
        let newfoto = JSON.parse(value.request.response)
        //console.log("Dopo Upload ", newfoto);
        this.utenteService.InfoUtenteConnesso.foto = newfoto['descrMessage'];
        this.utenteService.changedUser.next(this.utenteService.InfoUtenteConnesso);
        this.foto = environment.BASE_PUBLIC_IMAGE + newfoto['descrMessage'] + "?timestamp=" + timestamp;
        //alert(this.foto,"Dopo Upload");
        this.foto1 = environment.BASE_PUBLIC_IMAGE + newfoto['descrMessage'] + "?timestamp=" + timestamp;
        //this.foto="assets/images/img_avatar2.png";

        notify({
            message: 'Immagine Profilo aggiornata con successo!',
            height: 45,
            width: 250,
            position: 'center center'
        }, "success", 2000);



        setTimeout(() => {

            this.menuUtente[0]['icon'] = this.foto;


            if (document.getElementsByClassName('imageProfileHeader')) {

                for (let i = 0; i < document.getElementsByClassName('imageProfileHeader').length; i++) {

                    (document.getElementsByClassName('imageProfileHeader').item(i) as HTMLImageElement).src = this.foto;


                }


            }

        }, 1000);


        //        alert("File Caricato");
    }

    VisualizzaPannello() {
        alert(this.isDrawerOpen + " ", "Title");
        this.isDrawerOpen = !this.isDrawerOpen;
        console.log(this.isDrawerOpen);
        //alert(this.isDrawerOpen+" ","Title");
    }

    changePwdClick() {
        //
        this.popupCambioVisible = true;
    }
    test1() {
        this.popupListaVisible = true;
    }
    ListaSelect(value: any) {
        //
    }
    // Menu 
    selectOpUtente(value: any) {

        if (this.dynamicInsert)
            this.dynamicInsert.clear();

        value = value.itemData;
        console.log(value);
        if (value.itemIndex == 33) {
            this.router.navigate(['/ana-comuni'], { skipLocationChange: true });
            return;
        }
        //private _overlaySidePanelService: OverlaySideFormService
        if (value.itemIndex == 3) {

            if (value.itemIndex == 3) {

                //this.popupComponentTitle = "Informazioni su Licenza";

                //this.popupComponentVisible = true;
                //const factory2 = this.componentFactoryResolver.resolveComponentFactory(NicaLicenzaInfoComponent);
                const id = "NicaLicenzaInfoComponent";

                this.userComponentService.setNewPopUp(id, 'NicaLicenzaInfoComponent', [], '500', null, null, false, true, "Informazioni su Licenza")

                this.userComponentService.outputComponent.subscribe(currentOutput => {
                    if (currentOutput.guid == id) {
                        if (currentOutput.name == "close") {
                            this.userComponentService.destroyCurrentOpenPopUpByGuid(id);
                            this.userComponentService.destroyOutputComponent();
                        }
                    }
                });


            }
        }

        if (value.itemIndex == 2) {
            let result = confirm("<i style='font-size:24px;margin-right: 50px' class='icon dx-icon-runner'></i><i>Sicuro?</i>", "Conferma il logout");
            result.then((dialogResult) => {
                if (dialogResult) {

                    this.utenteService.LogOut();
                    this.router.navigate(['/login'], {
                        skipLocationChange: true,
                        replaceUrl: true
                    }).then(() => {
                        window.location.reload();
                    });
                    //this.router.navigateByUrl("/");
                }
                //
            });
        }
        if (value.itemIndex == 1) { //Modifica Profilo

            this.popupVisible = true;
        }


    }

    selectUtility(evt) {

        console.log(evt.itemIndex)

        switch ((evt["itemData"]["value"] as string)) {

            case "email": {
                this.Email();
            } break;
            case "filemanager": {
                this.FileManager();
            } break;
            case "cer": {
                this.ListaCer();
            } break;
            case "rentri": {
                this.router.navigateByUrl('/login-rentri')
            } break;
            case "testLista": {
                this.popupListaVisible = true
            } break;
            case "glossary": {
                this.router.navigate(['/main/genera-anagrafica'], {
                    queryParams: {

                        api: "",
                        componentName: "GenerateFormComponent",
                        currentTabId: "00001",
                        currentTabName: "Help Developer",
                        data: {},
                        queryFilter: {},
                        service: ""

                    }
                })
            } break;
        }

    }



    selectedChild(routeItem: any): string {
        //alert("ww","eeeeeeeeeeeeeeee");
        if (!routeItem.children) {
            return;
        }
        for (let routeChildren of routeItem.children) {
            if (routeChildren.data.link === this.router.url) {
                return ': ' + routeChildren.data.title;
            }
        }
    }

    changeMenu(e: any) {
        if (e.itemData.value) {
            //alert(e.itemData.value,"wwwwwwwwwww");
        }

    }
    changeTheme(e: any) {
        if (e.itemData.value) {
            this.currentTheme = e.itemData.value;
            this.menuThemes[0].icon = e.itemData.icon;
            //alert(this.currentTheme);
            this.themeService.applyTheme(this.currentTheme);
        }
    }

    constructor(
        private userComponentService: ComponentService,
        private activateRoute: ActivatedRoute,
        /*private matDialog: MatDialog,*/
        private componentFactoryResolver: ComponentFactoryResolver,
        //private viewContainerRef: ViewContainerRef,       
        private menuService: NicaMenuService,
        private appService: Apiservice,
        private overlaySideService: OverlaySideFormService,
        private camponentService: ComponentService,
        private apiservice: Apiservice, public utenteService: Utenteservice, private routesService: RoutesService,
        private router: Router, private themeService: ThemeService) {
        const t = this;
        this.diRitorno.bind(this);
        this.userComponentService.numberOfNav.subscribe(NumTabsOpen => {
            this.NumTabsOpen = NumTabsOpen;
        })

        this.menuService.hoCambiatoMenu.subscribe(x => {
            console.log("qqqqqqqqqqqqqquaaaaaaaaaaaaa ", x)
            if (x != '') {
                this.menuAdmin = (x.mainMenuData.text == 'Admin')
            }
        })

        this.utenteService.changedUser.subscribe(function (value) {

            if (t.utenteService.InfoUtenteConnesso.idtipoutente >= 2) {

                //console.log("vadoooooooooooooooo ",t.menuRoutes);
            }

            // return;

            //console.log("xxxxxxxxxx",value['foto']);

            if (value['foto']) t.foto = environment.BASE_PUBLIC_IMAGE + value['foto'] + "?time=" + new Date().getTime();
            else t.foto = "assets/images/img_avatar2.png" + "?timestamp=" + new Date().getTime();
            t.foto1 = t.foto;
            //alert(this.foto,"foto");
            t.menuUtente[0]['icon'] = t.foto;
            //t.menuUtente[1]['icon'] = t.foto;
            t.nomeutente = t.utenteService.InfoUtenteConnesso.nomeCompleto
            t.token = t.utenteService.DammiToken();
            //alert(t.token,"TOKEN");
            t.tipoutente = "Ruolo : " + t.utenteService.InfoUtenteConnesso.tipoutente;
            t.licenza = t.utenteService.InfoUtenteConnesso.descr_licenza;
            // alert(t.tipoutente,"event change user");
            if (typeof this != 'undefined') {
                this.menuUtente[0]['items'][0]['icon'] = t.foto;
            }

        });

        //this.popupVisible=false;
        this.closeButtonOptionsProfilo = {
            text: "Chiudi",
            stylingMode: "text",
            icon: 'glyphicon icon-annulla-form',
            elementAttr: {
                style: 'color:white'
            },
            onClick: function (e) {
                t.popupVisible = false
            }
        };
        this.closeButtonOptions = {
            text: "Chiudi",
            icon: 'glyphicon icon-annulla-form',
            stylingMode: "text",
            elementAttr: {
                style: 'color:white'
            },
            onClick: function (e) {
                t.popupListaVisible = false;
                t.popupCambioVisible = false;
            }
        };



    }
    ngAfterViewInit(): void {

        this.AziendaDiLavoro = this.utenteService.InfoUtenteConnesso.aziendaSelected;

        // Usa un setTimeout per garantire che l'elemento sia caricato
        setTimeout(() => {
            const element = this.cambioPasswordForm ? this.cambioPasswordForm.elementRef['vecchiaPassword'].htmlElement : undefined;
            if (element) {
                element.type = 'password'; // Imposta l'input come tipo 'password' inizialmente
                console.log(`Inizializzazione con ritardo: Tipo dell'input impostato su 'password' per vecchiaPassword`);
            } else {
                console.error("Errore: L'elemento dell'input 'vecchiaPassword' non è stato trovato.");
            }
        }, 0); // Ritardo minimo per garantire che l'elemento sia disponibile
    }
    ngAfterViewChecked(): void {
        // Verifica che this.cambioPasswordForm e elementRef esistano prima di accedere a htmlElement
        const fields = ['vecchiaPassword', 'nuovaPassword', 'ripetiNuovaPassword'];

        fields.forEach((field) => {
            if (this.cambioPasswordForm && this.cambioPasswordForm.elementRef && this.cambioPasswordForm.elementRef[field]) {
                const element = this.cambioPasswordForm.elementRef[field].htmlElement;

                // Imposta l'input come 'password' solo se non è visibile
                if (element && element.type !== 'password' && !this.passwordVisibility[field]) {
                    element.type = 'password'; // Imposta l'input come tipo 'password'
                    console.log(`Tipo dell'input impostato su 'password' per ${field} in ngAfterViewChecked`);
                }
            } else {
                //      console.error(`Errore: 'elementRef' o '${field}' non è stato trovato.`);
            }
        });
    }





    Email() {

        this.popupComponentTitle = "Email";
        this.popupComponentVisible = true;

        const factory2 = this.componentFactoryResolver.resolveComponentFactory(EmailComponent);
        //this.dynamicInsert.clear();

        setTimeout(() => {


            this.dynamicInsert.createComponent(factory2, 0);
        }, 100);

        //this.router.navigate(["main/email"])

    }
    Dammitoken() {
        return this.utenteService.DammiToken();

    }


    ListaCer() {
        this.popupComponentTitle = "Cer";
        this.popupComponentVisible = true;
        const factory2 = this.componentFactoryResolver.resolveComponentFactory(CerComponent);

        //this.dynamicInsert.clear();

        setTimeout(() => {


            this.dynamicInsert.createComponent(factory2, 0);

        }, 100);
    }

    FileManager() {
        this.popupComponentTitle = "File Manager";
        this.popupComponentVisible = true;
        const factory2 = this.componentFactoryResolver.resolveComponentFactory(NicaFileManagerComponent);

        //this.dynamicInsert.clear();

        setTimeout(() => {


            this.dynamicInsert.createComponent(factory2, 0);

        }, 100);
    }


    messaggioFromComponent(message: messagefromComponent) {
        //
        if (message.traceMessage == 'diretta') {
            // console.log("In header uisonline ",this.isOnLine)
            this.isOnLine = message.value.is_live
        }
    }

    ngOnInit() {


        this.userComponentService.castMessage.subscribe((message: messagefromComponent) => this.messaggioFromComponent(message));

        this.linkDiretta = "https://vimeo.com/event/1698194/embed?autoplay=1&loop=0&muted=1"

        this.activateRoute.queryParams.subscribe(params => {
            this.Tab = params.currentTabId;
            console.log("in header ", params)
        })


        this.currenAnnoRiferimento = '';
        this.AnniRiferimento = [];
        //this.utenteService.InfoUtenteConnesso.aziendaSelectedAnnoInstallazione
        const currentYear = new Date().getFullYear();
        for (var i = this.utenteService.InfoUtenteConnesso.aziendaSelectedAnnoInstallazione; i <= currentYear + 1; i++) {
            this.AnniRiferimento.push(i + "");
        }
        if (this.utenteService.InfoUtenteConnesso.annoSelected > 0)
            this.currenAnnoRiferimento = "" + this.utenteService.InfoUtenteConnesso.annoSelected;
        else
            this.currenAnnoRiferimento = currentYear + "";
        if (this.utenteService.InfoUtenteConnesso.idtipoutente == 1 || this.utenteService.InfoUtenteConnesso.idtipoutente == 6 || this.utenteService.InfoUtenteConnesso.idtipoutente == 10 || this.utenteService.InfoUtenteConnesso.idtipoutente == 11) {
            this.menuUtente =
                [{
                    text: "",
                    value: 'header',
                    src: this.foto,//assets/images/img_avatar2.png
                    items: [


                        { itemIndex: 2, text: "Esci dalla Piattaforma", value: "logout", icon: "icon-log-out", }, //assets/images/log-out.png
                    ]

                }];
            //this.menuUtente[0].items.splice(2,3);
        }
        else if (this.utenteService.InfoUtenteConnesso.idtipoutente == 3) {

            this.menuUtente =
                [{
                    text: "",
                    value: 'header',
                    src: this.foto,//assets/images/img_avatar2.png
                    class: 'imageProfileHeader',
                    items: [

                        { itemIndex: 1, text: "Modifica Profilo", value: "profilo", icon: this.foto, class: 'imageProfileHeader' },
                        //{ itemIndex:4,text: "Pannello Notifiche", value: "notifiche", icon: "icon-chat" },
                        { itemIndex: 3, text: "Informazioni su Licenza", value: "info", icon: "icon-info" },
                        { itemIndex: 2, text: "Esci dalla Piattaforma", value: "logout", icon: "icon-log-out", }, //assets/images/log-out.png
                    ]

                }];


            //this.menuUtente[0].items.splice(1,0,{ itemIndex:4,text: "Pannello Notifiche", value: "notifiche", icon: "icon-chat" });
        }
        else {
            this.menuUtente =
                [{
                    text: "",
                    value: 'header',
                    src: this.foto,//assets/images/img_avatar2.png
                    class: 'imageProfileHeader',
                    items: [

                        { itemIndex: 1, text: "Modifica Profilo", value: "profilo", icon: this.foto, class: 'imageProfileHeader' },
                        //{ itemIndex:4,text: "Pannello Notifiche", value: "notifiche", icon: "icon-chat" },
                        { itemIndex: 3, text: "Informazioni su Licenza", value: "info", icon: "icon-info" },
                        { itemIndex: 2, text: "Esci dalla Piattaforma", value: "logout", icon: "icon-log-out", }, //assets/images/log-out.png
                    ]

                }];
        }

        this.base_api_url = environment.BASE_API_URL;
        //console.log(this.base_api_url,"base_api_url");

        let value = this.utenteService.InfoUtenteConnesso;
        let t: this;
        if (value['foto'])
            this.foto = environment.BASE_PUBLIC_IMAGE + value['foto'] + "?time=" + new Date().getTime();
        else
            this.foto = "assets/images/img_avatar2.png" + "?timestamp=" + new Date().getTime();
        this.foto1 = this.foto;

        this.menuUtente[0]['icon'] = this.foto;


        console.log("eccoooooooooooooooooooooooooo il menu ", this.menuUtente)

        this.utenteService.getValueAnnoRiferimento().subscribe((value) => {

        });


        this.userComponentService.castMessage.subscribe(message => this.messaggioFromComponent(message));


        this.token = this.utenteService.DammiToken();


        if (!this.utenteService.AccessiExagerato.connesso) {
            // this.router.navigate(['/'], {skipLocationChange: true});
            //this.router.navigateByUrl("/");
        } else {


        };

        setTimeout(() => {
            //console.log("ECCO LE LICENZE ",this.utenteService.InfoUtenteConnesso.licenze);
            this.InfoLicenze = this.utenteService.InfoUtenteConnesso.licenze;
            console.log("this.utenteService.InfoUtenteConnesso ", this.utenteService.InfoUtenteConnesso);
            this.DB = this.utenteService.InfoUtenteConnesso.aziende;
            //console.log("ecco le aziendeeeeeeeeeeee ",this.utenteService.InfoUtenteConnesso.aziende);
            //annoInstallazione 2023
            this.creaHeader(this.utenteService.InfoUtenteConnesso.idtipoutente)

        }, 100);
        this.menuUtente[0]['items'][0]['icon'] = this.foto;
    }


    HoCambiatoAnno(e: any) {
        this.utenteService.setValueAnnoRiferimento(e.selectedItem)
    }

    HoCambiatoLicenza(e: any) {

    }
    HoCambiatoAzienda(e: any) {

        const idLicenza = this.utenteService.InfoUtenteConnesso.licenza;

        this.menuService.destroyCronNav();
        sessionStorage.removeItem('currentTabsItems')
        sessionStorage.removeItem('navComponent')
        //this.userComponentService.destroyComponentNavigation();
        this.router.navigate(["login"], {

            queryParams: {
                idAzienda: e.value,
                idLicenza: idLicenza
            },
            skipLocationChange: true,
            replaceUrl: true
        }
        )

        return

        if (this.ExAziendaDiLavoro !== this.AziendaDiLavoro) {
            this.ExAziendaDiLavoro = this.AziendaDiLavoro;
            this.utenteService.InfoUtenteConnesso.aziendaSelected = this.AziendaDiLavoro;
            this.appService.SetDBLavoro(this.AziendaDiLavoro).then(response => {


                this.menuService.changeAzienda();

                this.router.navigate(["login"], {
                    queryParams: {
                        idAzienda: e.value
                    },
                    skipLocationChange: true,
                    replaceUrl: true
                }
                )
            })

        }
        //alert("Cambiato Azienda di Lavoro "+this.AziendaDiLavoro,"Cambiato Azienda di Lavoro ")
        //
    }
    hideList() {


        //this.defaultVisible = !this.defaultVisible

        document.body.classList.toggle('hide-menu-all')


    }


    btnTest(e: any) {
        console.log(this.utenteService.InfoUtenteConnesso);
        alert("wwww", "wwwwwwwwww");
    }



    chiudiPopupHeader() {
        this.popupComponentTitle = "";

        if (this.dynamicInsert)
            this.dynamicInsert.clear();

        this.popupComponentVisible = false;

    }
    onShowing(e: any, isPasswordChange?: boolean) {
        e.component.content().parentNode.classList.add("bg-grey"); //add class to overlay content
        e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
        //e.component.content().parentNode.classList.add("popup"); //add class to overlay content
        e.component.content().classList.add("soggetto-form"); //add class to content

        //e.component.content().classList.add("formEditAna"); //add class to content

        if (!isPasswordChange) {
            setTimeout(
                () => {

                    if (!this.profiloForm)
                        return;

                    this.profiloForm.formRefreshInputData('userName', this.utenteService.InfoDatiUtenteConnesso.userName);
                    this.profiloForm.formRefreshInputData('nomeCompleto', this.utenteService.InfoDatiUtenteConnesso.nomeCompleto);
                    this.profiloForm.formRefreshInputData('codiceFiscale', this.utenteService.InfoDatiUtenteConnesso.codiceFiscale);
                    this.profiloForm.formRefreshInputData('telefono', this.utenteService.InfoDatiUtenteConnesso.telefono);
                    this.profiloForm.formRefreshInputData('emailComunicazioni', this.utenteService.InfoDatiUtenteConnesso.emailComunicazioni);
                    this.profiloForm.formRefreshInputData('emailRecupero', this.utenteService.InfoDatiUtenteConnesso.emailRecupero);
                    this.profiloForm.formRefreshInputData('accessoConPIN', this.utenteService.InfoDatiUtenteConnesso.accessoConPIN);


                }, 500
            )
        }
        else {

            if (!this.cambioPasswordForm)
                return;


            this.cambioPasswordForm.formEdit.instance.resetValues();
        }

    }

    onHiding(evt, isChangingPassword?: boolean) {


        if (this.profiloForm && !isChangingPassword)
            this.profiloForm.formEdit.instance.resetValues();


        if (this.cambioPasswordForm && isChangingPassword == true) {

            this.cambioPasswordForm.formEdit.instance.resetValues();


            let vecchiaPasswordEditor = this.cambioPasswordForm.formEdit.instance.getEditor('vecchiaPassword');
            let nuovaPasswordEditor = this.cambioPasswordForm.formEdit.instance.getEditor('nuovaPassword');
            let ripetiNuovaPasswordEditor = this.cambioPasswordForm.formEdit.instance.getEditor('ripetiNuovaPassword');


            vecchiaPasswordEditor.option('mode', 'password');
            nuovaPasswordEditor.option('mode', 'password');
            ripetiNuovaPasswordEditor.option('mode', 'password');


        }


    }

    gestisciEventoFormProfilo(evt, isChangingPassword?: boolean) {

        //console.warn(evt);
        console.log('sono dentro gli eventi', evt);


        switch (evt.name) {

            case 'annulla': {

                if (isChangingPassword == true)
                    this.popupCambioVisible = false;
                else
                    this.popupVisible = false;

            } break;

            case 'salva': {
                console.log('ciao');
                if (isChangingPassword == true) {
                    console.log('ciao, due');
                    let validate = this.cambioPasswordForm.validate();

                    if (!validate.isValid)
                        return;
                    console.log('ciao, tre');
                    if (this.cambioPasswordForm.dataSet['nuovaPassword'] !== this.cambioPasswordForm.dataSet['ripetiNuovaPassword']) {
                        alert("La nuova Password non conincide con la ripetizione", "Attenzione");
                        return;
                    }

                    this.apiservice.ForcePassword(this.utenteService.InfoUtenteConnesso, this.cambioPasswordForm.dataSet['vecchiaPassword'], this.cambioPasswordForm.dataSet['nuovaPassword'])
                        .then(
                            (ris) => {

                                notify({
                                    message: ris['descrMessage'],
                                    height: 45,
                                    width: 250,
                                    position: 'center center'
                                }, "success", 2000);

                                this.popupCambioVisible = false;
                            }
                        ).catch(
                            (err) => {
                                console.warn(err);
                            }
                        );
                }
                else {

                    console.log('sono in modifica ')
                    let validate = this.profiloForm.validate();

                    if (!validate.isValid)
                        return;
                    console.log(this.profiloForm.dataSet['username'], 'modifica dati')
                    let body: IUpdateProfiloRequest = {

                        id: this.utenteService.InfoDatiUtenteConnesso.idAccount,
                        userName: this.profiloForm.dataSet['userName'],
                        nomeCompleto: this.profiloForm.dataSet['nomeCompleto'],
                        codiceFiscale: this.profiloForm.dataSet['codiceFiscale'],
                        telefono: this.profiloForm.dataSet['telefono'] ? this.profiloForm.dataSet['telefono'].toString() : undefined,
                        foto: this.utenteService.InfoDatiUtenteConnesso.foto,
                        emailComunicazioni: this.profiloForm.dataSet['emailComunicazioni'],
                        emailRecupero: this.profiloForm.dataSet['emailRecupero'],
                        accessoConPIN: this.profiloForm.dataSet['accessoConPIN'] == true ? 1 : 0,
                    };



                    this.apiservice.PutUserInfo(body).then(response => {
                        console.log("login", response);
                        this.popupListaVisible = false;
                        this.popupVisible = false;

                        //asseganzione uno alla volta

                        this.utenteService.InfoUtenteConnesso.codiceFiscale = this.profiloForm.dataSet['codiceFiscale'],
                            this.utenteService.InfoUtenteConnesso.emailComunicazioni = this.profiloForm.dataSet['emailComunicazioni'],
                            this.utenteService.InfoUtenteConnesso.accessoConPIN = this.profiloForm.dataSet['accessoConPIN'] == true ? 1 : 0,
                            this.utenteService.InfoUtenteConnesso.telefono = this.profiloForm.dataSet['telefono'] ? this.profiloForm.dataSet['telefono'].toString() : undefined,
                            this.utenteService.InfoUtenteConnesso.emailRecupero = this.profiloForm.dataSet['emailRecupero'],
                            this.utenteService.InfoUtenteConnesso.nomeCompleto = this.profiloForm.dataSet['nomeCompleto'],
                            //this.utenteService.InfoUtenteConnesso.numeroGiorniScadenzaPassword = this.profiloFormData.numeroGiorniScadenzaPassword;
                            //this.utenteService.InfoUtenteConnesso.scadenzaAccount = this.profiloFormData.scadenzaAccount;


                            this.utenteService.InfoDatiUtenteConnesso.codiceFiscale = this.profiloForm.dataSet['codiceFiscale'],
                            this.utenteService.InfoDatiUtenteConnesso.emailComunicazioni = this.profiloForm.dataSet['emailComunicazioni'],
                            this.utenteService.InfoDatiUtenteConnesso.accessoConPIN = this.profiloForm.dataSet['accessoConPIN'] == true ? 1 : 0,
                            this.utenteService.InfoDatiUtenteConnesso.telefono = this.profiloForm.dataSet['telefono'] ? this.profiloForm.dataSet['telefono'].toString() : undefined,
                            this.utenteService.InfoDatiUtenteConnesso.emailRecupero = this.profiloForm.dataSet['emailRecupero'],
                            this.utenteService.InfoDatiUtenteConnesso.nomeCompleto = this.profiloForm.dataSet['nomeCompleto'],
                            //this.utenteService.InfoDatiUtenteConnesso.numeroGiorniScadenzaPassword = this.profiloFormData.numeroGiorniScadenzaPassword;
                            //this.utenteService.InfoDatiUtenteConnesso.scadenzaAccount = this.profiloFormData.scadenzaAccount;
                            notify({
                                message: 'Profilo Aggiornato con successo',
                                height: 45,
                                width: 250,
                                position: 'center center'
                            }, "success", 2000);
                        sessionStorage.setItem('userrentrincloud', JSON.stringify(this.utenteService.InfoUtenteConnesso));
                        this.utenteService.changedUser.emit(this.utenteService.InfoUtenteConnesso);
                    });

                }
            } break;
        }






        if (evt.name)
            switch (evt.name) {

                case 'cambioPassword':
                    this.popupCambioVisible = true;
                    break;

                case 'mostraPasswordAttuale':
                    this.togglePasswordVisibility('vecchiaPassword');
                    break;

                case 'mostraPasswordNuova':
                    this.togglePasswordVisibility('nuovaPassword');
                    break;

                case 'mostraPasswordRipetuta':
                    this.togglePasswordVisibility('ripetiNuovaPassword');
                    break;
            }


    }

    creaHeader(tipo: any) {

        this.getCurrentLicenza = this.utenteService.InfoUtenteConnesso['licenzeSelected'];
        this.DescrizioneLicenza = this.utenteService.InfoUtenteConnesso['descr_licenza'];
        //console.log("ecco this.utenteService.InfoUtenteConnesso ",this.utenteService.InfoUtenteConnesso)
        //console.log("ECCO IL TIPO MENU ",tipo)

        switch (tipo) {

            case 1:

                this.headerOption.selAzienda = false;
                this.headerOption.selLicenze = false;
                this.headerOption.selDB = false;
                this.headerOption.logo = true;
                this.headerOption.hideMenu = false;
                this.headerOption.hideBackIcon = false;
                this.headerOption.linkHome = "#/owner";
                this.headerOption.dashLabel = "Admin";
                this.headerOption.prefMenu = false;
                this.headerOption.swaggerTemp = !environment.production;
                this.headerOption.menuTheme = false;
                this.headerOption.menuProfile = true;
                this.headerOption.listaPopup = false;
                this.headerOption.EmailComponent = false;
                this.headerOption.listaComuni = false;
                this.headerOption.listaCer = false;
                this.headerOption.setting = false;
                this.headerOption.styleOption = { background: '#023957', padding: '1px 10px' };

                break;
            case 2:

                this.headerOption.logo = true;
                this.headerOption.hideMenu = false;
                this.headerOption.hideBackIcon = false;
                this.headerOption.linkHome = "#/owner";
                this.headerOption.dashLabel = "Admin";
                this.headerOption.prefMenu = false;
                this.headerOption.swaggerTemp = !environment.production;
                this.headerOption.menuTheme = false;
                this.headerOption.menuProfile = true;
                this.headerOption.listaPopup = false;
                this.headerOption.EmailComponent = false;
                this.headerOption.listaComuni = false;
                this.headerOption.listaCer = false;
                this.headerOption.setting = false;
                this.headerOption.selAzienda = true;
                this.headerOption.selLicenze = false;
                this.headerOption.selDB = false;

                this.headerOption.styleOption = { padding: '1px 10px' };


                break;
            case 3:
                this.ShowRentri = false;
                this.headerOption.logo = true;
                this.headerOption.hideMenu = true;
                this.headerOption.hideBackIcon = false;
                this.headerOption.linkHome = "/";
                this.headerOption.dashLabel = "Dashboard";
                this.headerOption.prefMenu = true;
                this.headerOption.swaggerTemp = !environment.production;
                this.headerOption.menuTheme = false;
                this.headerOption.menuProfile = true;
                this.headerOption.listaPopup = true;
                this.headerOption.EmailComponent = true;
                this.headerOption.selAzienda = false;
                this.headerOption.selLicenze = false;
                this.headerOption.selDB = true;

                this.headerOption.listaComuni = true;
                this.headerOption.listaCer = true;
                this.headerOption.setting = false;
                this.headerOption.styleOption = '';

                break;
            case 4:
            case 5:

                this.headerOption.logo = true;
                this.headerOption.hideMenu = true;
                this.headerOption.hideBackIcon = true;
                this.headerOption.linkHome = "/";
                this.headerOption.dashLabel = "Dashboard";
                this.headerOption.prefMenu = true;
                this.headerOption.swaggerTemp = !environment.production;
                this.headerOption.menuTheme = false;
                this.headerOption.menuProfile = true;
                this.headerOption.listaPopup = true;
                this.headerOption.EmailComponent = true;
                this.headerOption.selAzienda = false;
                this.headerOption.selLicenze = false;
                this.headerOption.selDB = true;

                this.headerOption.listaComuni = true;
                this.headerOption.listaCer = true;
                this.headerOption.setting = false;
                this.headerOption.styleOption = '';
                break;
            case 6:
                this.headerOption.logo = true;
                this.headerOption.hideMenu = true;
                this.headerOption.hideBackIcon = false;
                this.headerOption.linkHome = "";
                this.headerOption.dashLabel = "Registro Elettronico";
                this.headerOption.prefMenu = true;
                this.headerOption.swaggerTemp = false;//!environment.production;
                this.headerOption.menuTheme = false;
                this.headerOption.menuProfile = true;
                this.headerOption.listaPopup = true;
                this.headerOption.EmailComponent = true;
                this.headerOption.selAzienda = false;
                this.headerOption.selLicenze = false;
                this.headerOption.selDB = true;

                this.headerOption.listaComuni = false;
                this.headerOption.listaCer = false;
                this.headerOption.setting = false;
                this.headerOption.styleOption = '';
                break;
            case 10:
            case 11:
                this.headerOption.logo = true;
                this.headerOption.hideMenu = false;
                this.headerOption.hideBackIcon = false;
                this.headerOption.linkHome = "/";
                this.headerOption.prefMenu = false;
                this.headerOption.swaggerTemp = !environment.production;
                this.headerOption.menuTheme = false;
                this.headerOption.menuProfile = true;
                this.headerOption.listaPopup = false;
                this.headerOption.EmailComponent = true;
                this.headerOption.selAzienda = false;
                this.headerOption.selLicenze = false;
                this.headerOption.selDB = false;

                this.headerOption.listaComuni = false;
                this.headerOption.listaCer = false;
                this.headerOption.setting = false;
                this.headerOption.styleOption = '';
                break
            default:

                this.headerOption.logo = true;
                this.headerOption.hideMenu = false;
                this.headerOption.hideBackIcon = true;
                this.headerOption.linkHome = "/";
                this.headerOption.dashLabel = "Dashboard";
                this.headerOption.prefMenu = false;
                this.headerOption.swaggerTemp = true;
                this.headerOption.menuTheme = false;
                this.headerOption.menuProfile = false;
                this.headerOption.listaPopup = false;
                this.headerOption.EmailComponent = false;
                this.headerOption.listaComuni = false;
                this.headerOption.selAzienda = false;
                this.headerOption.selLicenze = false;
                this.headerOption.selDB = true;

                this.headerOption.listaCer = false;
                this.headerOption.setting = true;
                this.headerOption.styleOption = { background: '#444791', padding: '1px 10px' };

                break;
        }
    }
    diRitorno(data) {
        return;
        if (!data.value) return;
        //alert("Sono Tornato","di ritorno")
        (document.getElementById('fotoProfilo') as HTMLImageElement).src = data.value;

        data.key.apiservice.PostApi("Account/addImageProfile/image", data.value).then(x => {
            console.log("dopo upload ", x)
        })

        //convertire da b64 a file 


        //form.append(,);

        //this.foto=data;
        console.log("Ecco la foto ", data)
    }
    OpenWebCam() {
        let data = {
            idUser: 12
        };

        this.camponentService.openComponent("WebcamnicaComponent", data, "Foto", 800, 400, this.diRitorno, this);

        // Gestione dell'output quando il componente WebcamnicaComponent viene chiuso
        this.camponentService.outputComponent.subscribe(x => {
            console.log("Chiusura componente WebcamnicaComponent", x);
        });

        // Crea un timestamp unico per evitare il caching dell'immagine
        const timestamp = new Date().getTime();

        // Gestione dei dati ricevuti dal componente WebcamnicaComponent
        this.camponentService.dataFromComponent.subscribe(x => {
            console.log("Ho Ricevuto i dati ", x);

            // Converti la stringa Base64 in un oggetto Blob
            const byteString = atob(x.split(',')[1]); // Decodifica la parte Base64
            const mimeString = x.split(',')[0].split(':')[1].split(';')[0]; // Ottieni il tipo MIME

            // Crea un ArrayBuffer e lo popola con i byte dell'immagine
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            // Crea un oggetto Blob con il contenuto dell'immagine
            const blob = new Blob([ab], { type: mimeString });

            // Crea un URL temporaneo per il Blob da usare come sorgente dell'immagine
            const imageUrl = URL.createObjectURL(blob);

            // Mostra l'immagine catturata dalla webcam nell'elemento <img> con id 'fotoProfilo'
            (document.getElementById('fotoProfilo') as HTMLImageElement).src = imageUrl;

            // Crea un FormData e aggiungi il blob
            const formData = new FormData();
            formData.append('image', blob, 'webcam-photo.png'); // Assegna un nome al file

            // Usa FormData per inviare l'immagine all'API
            this.apiservice.PostApi("Account/addImageProfile/", formData)
                .then(response => {
                    console.log("dopo upload ", response);

                    // Rilascia l'oggetto URL per liberare memoria
                    URL.revokeObjectURL(imageUrl);
                })
                .catch(error => {
                    console.error('Errore durante il caricamento dell\'immagine', error);
                    alert('Errore durante il caricamento dell\'immagine: ' + error.message, 'Errore');
                });
        });

    }

    // metodo per rendere visibile e non password
    togglePasswordVisibility(fieldName: string) {
        const element = this.cambioPasswordForm.elementRef[fieldName].htmlElement;

        // Cambia il tipo di input in base al tipo corrente
        if (this.passwordVisibility[fieldName]) {
            element.type = 'password'; // Nascondi la password
            this.passwordVisibility[fieldName] = false; // Aggiorna il flag per il campo specifico
            console.log(`Tipo cambiato a 'password' per ${fieldName}`);
        } else {
            element.type = 'text'; // Mostra la password
            this.passwordVisibility[fieldName] = true; // Aggiorna il flag per il campo specifico
            console.log(`Tipo cambiato a 'text' per ${fieldName}`);
        }
    }



}
